import axios from 'axios';
import {
  HOST_API,
  AUTHORIZATION,
  TEST_URL,
  STAGE_CORE_URL,
  STAGING_URL,
  TEST_URL_CORE_HTTPS,
  PROD_URL_CORE_HTTPS,
} from 'src/config-global';

// Create an Axios insta
const coreAxios = axios.create({
  // baseURL: `${HOST_API}:6568`,
  // baseURL: "http://139.59.63.178:6568",
  // baseURL: `${TEST_URL}:6568`,
  // baseURL: PROD_URL_CORE_HTTPS,
  baseURL: STAGE_CORE_URL,
  headers: {
    Authorization: AUTHORIZATION,
    'Content-Type': 'application/json',
  },
});

export default coreAxios;
